import {InlineAlert} from 'letrus-ui';
import {useState} from 'react';

const SESSION_STORAGE_KEY = 'hideAiUsageAlert';

const ALERT_TEXT =
  'Seu texto, suas ideias. A IA pode ser útil como parceira de estudo: peça explicações, ' +
  'fontes para pesquisar ou ajuda para organizar suas ideias. Mas escreva você. É praticando ' +
  'que sua escrita evolui. E confira sempre as informações antes de usá-las: como em qualquer ' +
  'fonte, é importante verificar o que a IA apresenta.';

function AiUsageAlert() {
  const [closedByUser, setClosedByUser] = useState(false);

  const closedOnSession =
    sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true';

  return !closedByUser && !closedOnSession ? (
    <InlineAlert
      backgroundColor="#fff6db"
      mainColor="#a66f00"
      textColor="#000000"
      firstButtonText="Fechar"
      leftIcon={{icon: ['fad', 'circle-info']}}
      onClickFirstButton={() => {
        sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
        setClosedByUser(true);
      }}
    >
      <p>{ALERT_TEXT}</p>
    </InlineAlert>
  ) : null;
}

export default AiUsageAlert;
